var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0.5 0 24 24",
    enableBackground: "new 0.5 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0c-6.627,0-12,5.373-12,12c0,6.628,5.373,12,12,12c6.628,0,12-5.372,12-12C24.5,5.373,19.128,0,12.5,0z  M20.278,19.778C18.286,21.77,15.539,23,12.5,23s-5.786-1.23-7.778-3.222C2.73,17.786,1.5,15.039,1.5,12s1.23-5.786,3.222-7.778 C6.714,2.23,9.461,1,12.5,1s5.786,1.23,7.778,3.222C22.27,6.214,23.5,8.961,23.5,12S22.27,17.786,20.278,19.778z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default __webpack_public_path__ + "static/media/indicator.42228393decd5126b91462ed3ea12821.svg";
export { ForwardRef as ReactComponent };